<ng-container *ngIf="!generated">
  <h1 mat-dialog-title>Set statement period</h1>

  <mat-dialog-content>
    <form [formGroup]="form"
          class="statement-form">
      <div class="fields-row">
        <mat-form-field *ngIf="entityMode"
                        appearance="outline"
                        class="field field--loan"
                        [class.field--selected]="selectedLoanOption">
          <mat-label>Loan</mat-label>
          <mat-select formControlName="loan">
            <mat-select-trigger *ngIf="selectedLoanOption">
              <span class="loan-option">
                <mat-icon class="loan-option__icon">{{ selectedLoanOption.icon }}</mat-icon>
                <span>{{ selectedLoanOption.display }}</span>
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let option of loanOptions; trackBy: trackByLoanId"
                        [value]="option">
              <span class="loan-option">
                <mat-icon class="loan-option__icon">{{ option.icon }}</mat-icon>
                <span>{{ option.display }}</span>
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ifp-month-year-picker class="field field--period"
                               formControlName="period"
                               [accountOpenedOn]="pickerAccountOpenedOn"
                               [invalid]="hasStatusError"></ifp-month-year-picker>

        <mat-form-field appearance="outline"
                        class="field field--format"
                        [class.field--selected]="formatSelected">
          <mat-label>Statement format</mat-label>
          <mat-select formControlName="format">
            <mat-option *ngFor="let option of formatOptions; trackBy: trackByFormat"
                        [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <p class="status-message"
         *ngIf="statusMessage">{{ statusMessage }}</p>
    </form>
  </mat-dialog-content>

  <div mat-dialog-actions
       class="flex row end-center statement-dialog-actions">
    <button mat-button
            [mat-dialog-close]="false">Cancel</button>
    <button mat-button
            color="primary"
            *ngIf="!generating"
            [disabled]="submitDisabled"
            (click)="generate()">Submit</button>
    <mat-spinner *ngIf="generating"
                 class="submit-spinner"
                 diameter="24"></mat-spinner>
  </div>
</ng-container>

<ng-container *ngIf="generated">
  <h1 mat-dialog-title>Statement generated</h1>

  <mat-dialog-content>
    <p class="generated-body">
      Your statement request has been generated. View the statement by pressing on the file below.
    </p>
    <button type="button"
            class="statement-file-link"
            (click)="downloadFile()">{{ generated.filename }}</button>
  </mat-dialog-content>

  <div mat-dialog-actions
       class="flex row end-center">
    <button mat-button
            color="primary"
            [mat-dialog-close]="true">OK</button>
  </div>
</ng-container>
